export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  if (!API_BASE_URL) {
    return p;
  } // relative path fallback (proxy or same origin)
  return `${API_BASE_URL}${p}`;
}
